export const residential_complex_filter = (item, filters) => {
  if (filters.residential_complex.length > 0) {
    if (
      !filters.residential_complex.includes(item.properties.residential_complex)
    )
      return false;
  }
  return true;
};

export const rooms_filter = (item, filters) => {
  if (filters.rooms.length > 0) {
    if (
      !(
        filters.rooms.includes(item.properties.rooms) ||
        (filters.rooms.includes('4+') && item.properties.rooms >= 4)
      )
    )
      return false;
  }
  return true;
};

export const price_filter = (item, filters) => {
  if (
    filters.cost_from !== null ||
    filters.cost_from !== undefined ||
    filters.cost_to !== null ||
    filters.cost_to !== undefined
  ) {
    if (
      !(
        (filters.cost_from || 0) <= item.properties.price &&
        (filters.cost_to || Infinity) >= item.properties.price
      )
    )
      return false;
  }
  return true;
};

export const renovation_level_filter = (item, filters) => {
  if (filters.renovation_level.length > 0) {
    if (!filters.renovation_level.includes(item.properties.condition))
      return false;
  }
  return true;
};

export const house_type_filter = (item, filters) => {
  if (filters.house_type.length > 0) {
    if (!filters.house_type.includes(item.properties.building_type))
      return false;
  }
  return true;
};

export const square_filter = (item, filters) => {
  if (
    filters.square_from !== null ||
    filters.square_from !== undefined ||
    filters.square_to !== null ||
    filters.square_to !== undefined
  ) {
    if (
      !(
        (filters.square_from || 0) <= item.properties.area &&
        (filters.square_to || Infinity) >= item.properties.area
      )
    )
      return false;
  }
  return true;
};

export const year_filter = (item, filters) => {
  if (
    filters.year_from !== null ||
    filters.year_from !== undefined ||
    filters.year_to !== null ||
    filters.year_to !== undefined
  ) {
    if (
      !(
        (filters.year_from || 0) <= item.properties.year &&
        (filters.year_to || Infinity) >= item.properties.year
      )
    )
      return false;
  }
  return true;
};

export const owner_filter = (item, filters) => {
  if (filters.from_owner) {
    if (!(item.properties.seller === 'owner')) return false;
    return true;
  }
  return true;
};

export const mortgage_filter = (item, filters) => {
  if (filters.mortgage) {
    if (!(item.properties.available_for_mortgage === 'Yes')) return false;
    return true;
  }
  return true;
};

export const tour_filter = (item, filters) => {
  if (filters.tour_3d) {
    if (!(item.properties['3d_tour'] === 'Yes')) return false;
    return true;
  }
  return true;
};

export const first_floor_filter = (item, filters) => {
  if (filters.first_floor) {
    if (!(item.properties.floor !== 1)) return false;
    return true;
  }
  return true;
};
